<template>
	<div
		class="c-contentSlider"
		:class="{
			'c-contentSlider--shadow': slideShadow,
			'c-contentSlider--inline': inline,
			'c-contentSlider--loading': loading,
		}"
	>
		<div class="c-contentSlider__wrapper">
			<div class="c-contentSlider__header">
				<div class="heading">
					<div class="heading__loading" v-if="loading"></div>
					<slot name="heading" v-else></slot>
				</div>
				<div
					class="navigation"
					:class="{ 'navigation--hidden': navigationHidden || loading }"
				>
					<div class="arrow prev" :class="['prev-' + contentId]">
						<ArrowIcon></ArrowIcon>
					</div>
					<div class="arrow next" :class="['next-' + contentId]">
						<ArrowIcon></ArrowIcon>
					</div>
				</div>
			</div>

			<div
				class="c-contentSlider__swiper"
				:class="{ 'c-contentSlider__swiper--overflow': slideOverflow }"
			>
				<swiper
					:slides-per-view="slidePerView"
					:navigation="{
						nextEl: '.next-' + contentId,
						prevEl: '.prev-' + contentId,
					}"
					:pagination="{ el: '.pagination-' + contentId, clickable: true }"
					:modules="[Navigation, Pagination]"
					:breakpoints="slideBreakpoints"
					:initial-slide="slideInit"
					:centered-slides="slideCenter"
					:loop="slideLoop"
					:space-between="slideSpacing"
					:id="['swiper-' + contentId]"
				>
					<slot name="slides"></slot>
				</swiper>
			</div>
			<div
				class="c-contentSlider__pagination"
				:class="['pagination-' + contentId]"
			></div>
		</div>
	</div>
</template>

<script>
//Swiper
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";

//Icons
import ArrowIcon from "@web/assets/icon/arrow-nav.svg";

export default {
	name: "ContentSlider",
	components: {
		ArrowIcon,

		Swiper,
		SwiperSlide,
	},
	props: {
		contentId: String,
		slideSpacing: {
			type: Number,
			default: 0,
		},
		slidePerColumn: {
			type: Number,
			default: 1,
		},
		slidePerView: {
			type: Number,
			default: 1,
		},
		slideInit: {
			type: Number,
			default: 0,
		},
		slideOverflow: {
			type: Boolean,
			default: false,
		},
		slideBreakpoints: {
			type: Object,
			default: {},
		},
		slideCenter: {
			type: Boolean,
			default: false,
		},
		slideLoop: {
			type: Boolean,
			default: false,
		},
		slideShadow: {
			type: Boolean,
			default: false,
		},
		inline: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			defualt: false,
		},
	},
	setup() {
		return {
			Navigation,
			Pagination,
		};
	},
	data: () => {
		return {
			navigationHidden: false,
		};
	},
	methods: {
		hideNavigation() {
			if (this.slideLoop) {
				this.navigationHidden = false;
				return;
			}

			let slideAmount = document
				.getElementById("swiper-" + this.contentId)
				?.getElementsByClassName("swiper-slide")?.length;

			if (parseInt(this.getSlidePerView()) >= parseInt(slideAmount)) {
				this.navigationHidden = true;
			} else {
				this.navigationHidden = false;
			}
		},
		getSlidePerView() {
			let perView = this.slidePerView;

			for (const [key, value] of Object.entries(this.slideBreakpoints)) {
				if (window.innerWidth >= key) {
					for (const [key, objectValue] of Object.entries(value)) {
						if (key == "slidesPerView") {
							perView = objectValue;
						}
					}
				}
			}
			return perView;
		},
	},

	mounted() {},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-contentSlider {
	overflow-x: hidden;

	&__header {
		@include grid-keep();
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 40px;

		.heading {
			&__loading {
				height: 40px;
				width: 70vw;
				max-width: 280px;
				@include loader-skeleton();
			}
		}

		.navigation {
			display: flex;
			gap: 24px;
			position: relative;
			right: -6px;

			.arrow {
				pointer-events: all;
				width: 32px;
				height: 32px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				svg {
					width: 19px;
					height: auto;
				}
			}
			.prev {
				transform: rotate(180deg);
			}

			.swiper-button {
				&-disabled {
					cursor: default;
					opacity: 0.5;
				}
			}

			&--hidden {
				display: none;
			}
		}
	}
	&__swiper {
		@include grid-keep();
		&--overflow {
			.swiper {
				&-container,
				&-wrapper {
					overflow: visible;
				}
			}
		}

		.swiper {
			&-slide {
				display: flex;
				height: unset;
				flex-grow: 1;
			}
		}
	}
	&__pagination {
		@include swiper-pagination();
		display: none;
	}

	&--shadow {
		.c-contentSlider {
			&__header {
				margin-bottom: 30px;
			}
			&__swiper {
				@include grid-keep();
				.swiper {
					&-container {
						margin-left: -20px;
						margin-right: -20px;
						padding: 10px 20px 30px;
					}
				}
			}
		}
	}

	&--inline {
		.swiper {
			&-slide {
				display: flex;
				height: unset;
				flex-grow: unset;
				max-width: unset;
			}

			&-container-multirow > .swiper-wrapper {
				flex-direction: row !important;
			}
		}
	}
}

@media all and (max-width: 594px) {
	.c-contentSlider {
		&--inline {
			.c-contentSlider__swiper {
				.swiper-wrapper {
					display: grid;
					grid-template-columns: 1fr;
					grid-template-rows: auto auto;
					grid-auto-flow: column;

					& > .swiper-slide {
						height: fit-content;
					}

					.o-catalogProduct {
						padding-bottom: 0;
					}
				}
			}

			.c-contentSlider__pagination {
				margin-top: 5px;
			}
		}
	}
}

@media all and (max-width: 550px) {
	.c-contentSlider {
		&__header {
			margin-bottom: 16px;
			align-items: center;

			.navigation {
				right: 0;
				.arrow {
					height: 19px;
					width: 15px;
					svg {
						width: 15px;
					}
				}
			}
		}
		&__pagination {
			display: flex;
		}
	}
}
</style>
